import Settings from '../../../../../settings/Settings';
import Total from './total/Total';

const TITLE = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 50,
    TINT: 0x000000,
};

export default class TotalBonus extends Phaser.GameObjects.Container {
    private config: any;
    private bg!: Phaser.GameObjects.Image;
    private title!: Phaser.GameObjects.BitmapText;
    private total!: Total;
    private button!: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number, config: any) {
        super(scene, x, y);

        this.config = config;

        this.setupBG();
        this.setupTitle();
        this.setupTotal();
        this.setupButton();
    }

    setupBG() {
        let frame = 'gui/friends/total_bonus_bg';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        this.bg.setOrigin(0.5, 0);
        this.add(this.bg);
    }

    setupTitle() {
        let x = -280;
        let y = 10;

        this.title = this.scene.add.bitmapText(x, y, TITLE.FONT, this.scene.cache.json.get('i18n')['total_bonus'], TITLE.SIZE);
        this.title.setTint(TITLE.TINT);
        this.add(this.title);
    }

    setupTotal() {
        let x = 120;
        let y = 10;

        this.total = new Total(this.scene, x, y, {});
        this.add(this.total);
    }

    setupButton() {
        let x = 0;
        let y = 130;
        let frame = 'gui/friends/button_claim_all';

        this.button = this.scene.add.image(x, y, 'atlas', frame);
        this.add(this.button);
    }
}
